###
# Услуги (тарифы)
###
App.Service = DS.Model.extend
  name              : DS.attr 'string'
  month_price       : DS.attr 'number'
  service_type      : DS.attr 'string'
  service_type_text : DS.attr 'string'
  is_tariff         : DS.attr 'boolean'
  is_hidden         : DS.attr 'boolean'
  actual_from       : DS.attr 'date'
  actual_until      : DS.attr 'date'
  features          : DS.attr 'string'
  restriction       : DS.attr 'string'

  subscriptions     : DS.hasMany 'service_subscription',    async : true

  featuresList: (->
    @get('features')?.split('\n')
  ).property('features')

  isFree: Em.computed.equal('restriction', 'free')
